import { render, staticRenderFns } from "./IlluFonctionSupports.vue?vue&type=template&id=2498731d&"
import script from "./IlluFonctionSupports.vue?vue&type=script&lang=js&"
export * from "./IlluFonctionSupports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports